import React from "react";
import { TitleLockup } from "@vds3/type-lockups";
import { useSelector } from "react-redux";
import { PromoHeaderContainer, StyledTitleLockupWrapper } from "./styles";
import HeroCopy from '../../../../common/components/HeroCopy/HeroCopy';


const PromoHeader = ({ aemContent, isMobile, isPortrait, isLaptop, isDesktop, isTablet, isLaptopByod ,isTabletByod }) => {
  const landing4gData = useSelector((state) => state.Landing4GPage);
  const subText = () => {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html:aemContent?.smartPhone?.subHeaderText ,
        }}
      />
    );
  };

  const headerTextTitle = () => {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: (isTablet && isPortrait) ? aemContent?.smartPhone?.headerTextTablet : aemContent?.smartPhone?.headerText,
        }}
      />
    );
  };

  return (
    <PromoHeaderContainer
      isMobile={isMobile}
      url={(isLaptopByod) ? (isMobile ? `${window?.mbtGlobal?.assetsBaseUrl}${aemContent?.laptop?.mobile_ss7ImgUrl}`
        : `${window?.mbtGlobal?.assetsBaseUrl}${aemContent?.laptop?.ss7ImgUrl}`
      )
        : (isTabletByod) ? (isMobile ? `${window?.mbtGlobal?.assetsBaseUrl}${aemContent?.tablet?.mobile_ss7ImgUrl}`
          : `${window?.mbtGlobal?.assetsBaseUrl}${aemContent?.tablet?.ss7ImgUrl}`
        )
          :
          (isMobile
            ? `${window?.mbtGlobal?.assetsBaseUrl}${aemContent?.smartPhone?.mobile_ss7ImgUrl}`
            : `${window?.mbtGlobal?.assetsBaseUrl}${aemContent?.smartPhone?.ss7ImgUrl}`
          )}
    >
      {landing4gData?.showHeroCopyForBundle ? <HeroCopy pageName="byod"></HeroCopy>:<StyledTitleLockupWrapper isMobile={isMobile}>
        <TitleLockup
          surface="dark"
          data={{
            subtitle: {
              size: `${(isTablet && isPortrait) ? "titleSmall" : isLaptop || isDesktop ? "titleSmall" : isMobile || (!isMobile && !isPortrait) ? "titleSmall" : "titleMedium"}`,
              primitive: `${(isTablet && isPortrait) ? 'h3' : isLaptop || isDesktop ? 'h2' : isMobile || (!isMobile && !isPortrait) ? 'h3' : 'h2'}`,
              children: subText(),
            },
            title: {
              size: `${isMobile || (!isMobile && !isPortrait) ? "titleXLarge" : "titleXLarge"}`,
              primitive: `${(isTablet && isPortrait) ? 'h1' : isLaptop || isDesktop ? 'h1' : isMobile || (!isMobile && !isPortrait) ? 'h2' : 'h1'}`,
              children: headerTextTitle(),
            },
          }} />
      </StyledTitleLockupWrapper> }
      
    </PromoHeaderContainer>
  );
};

export default PromoHeader;
